import type { KycResponse, IdnowProviderDetails } from '@repo/api-kit/queries/due-diligence/kyc';

export function getIdnowProviderDetails(kycInfo?: KycResponse | null): IdnowProviderDetails | null {
  return kycInfo?.activeProcess?.providerDetails?.$case === 'idnowProviderDetails'
    ? kycInfo.activeProcess.providerDetails.value
    : null;
}
